import { createDataAttribute } from "@sanity/visual-editing/create-data-attribute";
import { sanityStudioUrl } from "./client";

/**
 * Build a `data-sanity` attribute value pointing at a specific document field.
 *
 * Sanity Presentation overlays normally find their edit target from the
 * invisible stega payload on a rendered string. Some content can't carry that
 * payload to the scanner — strings handed to GSAP `SplitText` (it fractures the
 * zero-width payload) or injected via `dangerouslySetInnerHTML` after a
 * `cleanStegaForTextTransform`. For those, render this attribute on the element
 * instead; the overlay reads it directly (content detection method #3). It is
 * inert in production, where no overlay scanner runs.
 */
export function sanityEditAttribute(params: {
  id?: string | null;
  type?: string | null;
  path: string;
}): string | undefined {
  const {
    id,
    type,
    path
  } = params;
  if (!id || !type) {
    return undefined;
  }
  return createDataAttribute({
    // The studio addresses the published document; drop any `drafts.` prefix.
    id: id.replace(/^drafts\./, ""),
    type,
    path,
    baseUrl: sanityStudioUrl
  }).toString();
}